<div class="section-detail-produk">
  <div class="section-detail-produk__header">
    <span
      [inlineSVG]="STRING_CONSTANTS.ICON.IC_PESTISIDA"
      class="section-detail-produk__icon"
    ></span>
    <span class="section-detail-produk__title">Detail Produk</span>
  </div>

  <!-- [AC-02] Hanya untuk program yang menargetkan produk tertentu. -->
  <div *ngIf="hasSpecificProductTarget" class="section-detail-produk__note">
    <span
      [inlineSVG]="STRING_CONSTANTS.ICON.IC_INFORMATION_GREY"
      class="section-detail-produk__note-icon"
    ></span>
    <span>Produk telah ditentukan oleh Program Marketing.</span>
  </div>

  <!-- [MAI-2606 QA] Disembunyikan saat belum ada produk sama sekali; tetap tampil pada
       empty state hasil pencarian supaya kata kunci masih bisa dihapus. -->
  <app-input-search
    *ngIf="showSearch"
    (actionFilter)="onSearch($event)"
    [isFinishLoadingSubject]="isControlsReady"
    [value]="keyword"
    class="section-detail-produk__search"
    placeholder="Cari nama produk"
  ></app-input-search>

  <app-card-empty
    *ngIf="isEmpty"
    [icon]="STRING_CONSTANTS.ICON.IC_PESTISIDA_GRAY_FILL"
    [text]="emptyText"
  ></app-card-empty>

  <!--
    Tabel hanya disembunyikan, bukan dilepas dari DOM. `BaseDatasource.disconnect()` memanggil
    `tableSubject.complete()`, jadi begitu MatTable dilepas oleh `*ngIf` subject-nya mati dan
    baris tidak pernah muncul lagi saat pencarian direset.
  -->
  <div [class.d-none]="isEmpty">
    <div class="table-responsive">
      <table
        [dataSource]="dataSource"
        class="table w-100 table-row-bordered align-middle detail-produk-table"
        mat-table
      >
        <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.key">
          <th
            *matHeaderCellDef
            [ngClass]="{ 'w-70px': tableColumn.key === 'ratio_status' }"
            mat-header-cell
          >
            <app-table-content [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject">
              {{ tableColumn.title }}
            </app-table-content>
          </th>

          <td
            *matCellDef="let element"
            [ngClass]="{ 'w-70px text-center': tableColumn.key === 'ratio_status' }"
            mat-cell
          >
            <ng-container [ngSwitch]="tableColumn.key">
              <!-- Rasio Pembelian: "-" untuk produk tanpa ketentuan rasio. -->
              <div *ngSwitchCase="'purchase_ratio'">
                <app-table-content [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject">
                  <span>{{ element['purchase_ratio'] || '-' }}</span>
                </app-table-content>
              </div>

              <!--
                Progres punya dua bentuk (design node 8212-42251 vs 8217-51266):
                dua baris (kuantitas + nominal) pada tipe target Satuan Berat/Satuan Jual,
                dan satu baris saja pada tipe target Nominal. Baris yang berdiri sendiri
                selalu Neutral/Black; nominal baru abu-abu kalau ada baris kuantitas di atasnya.
              -->
              <div *ngSwitchCase="'progress'">
                <app-table-content
                  [count]="2"
                  [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
                  [type]="'text'"
                >
                  <div
                    *ngIf="element['progress_value']"
                    class="section-detail-produk__progress-value"
                  >
                    {{ element['progress_value'] }}
                  </div>
                  <div
                    *ngIf="element['progress_nominal']"
                    [class.section-detail-produk__progress-nominal--muted]="
                      !!element['progress_value']
                    "
                    class="section-detail-produk__progress-nominal"
                  >
                    {{ element['progress_nominal'] }}
                  </div>
                </app-table-content>
              </div>

              <!-- Centang hijau saat ketentuan rasio terpenuhi. -->
              <div *ngSwitchCase="'ratio_status'">
                <app-table-content
                  [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
                  [type]="'icon'"
                >
                  <span
                    *ngIf="element['is_completed_progress']"
                    [inlineSVG]="STRING_CONSTANTS.ICON.IC_CHECKLIST_GREEN_LARGE"
                    class="section-detail-produk__check"
                  ></span>
                </app-table-content>
              </div>

              <div *ngSwitchDefault>
                <app-table-content [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject">
                  <span>{{ element[tableColumn.key] }}</span>
                </app-table-content>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <tr
          *matHeaderRowDef="displayedColumns"
          class="fw-bold text-start text-uppercase"
          mat-header-row
        ></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
    </div>

    <div class="d-flex justify-content-between pt-4">
      <app-mai-material-bottom-table
        (changePage)="onPageChange($event)"
        [baseDataTableComponent]="dataSource"
        [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
        class="w-100"
      ></app-mai-material-bottom-table>
    </div>
  </div>
</div>
